import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { MarketplaceWalletItem, RewardsWalletQuery, ScreenSizeService } from '@fgb/core';
import { atcb_action } from 'add-to-calendar-button';
import { DateTime } from 'luxon';
@Component({
  selector: 'fgbcl-add-to-calendar-modal',
  templateUrl: './add-to-calendar-modal.component.html',
  styleUrl: './add-to-calendar-modal.component.scss',
})
export class AddToCalendarModalComponent implements OnInit {
  purchasedItem: MarketplaceWalletItem;
  calendarStartDate: any;
  calendarEndDate: any;
  calendarStartTime: any;
  calendarEndTime: any;
  screenSize: number = 0;
  button: any;
  config: any;
  configMobile: any;
  showCalendar: boolean = true;
  showButton: boolean = false;
  timeZoneOffset: any;
  @Input() googleIconName1: string = 'event_available';
  private destoryRef = inject(DestroyRef);

  constructor(
    private screenSizeServices: ScreenSizeService,
    private route: ActivatedRoute,
    private rewardWalletQuery: RewardsWalletQuery
  ) {}

  ngOnInit() {
    this.timeZoneOffset = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.getWalletData();
    this.screenSizeServices.selectScreenWidth().subscribe((size: number) => (this.screenSize = size));
    this.button = document.getElementById('my-event-button');
    this.setConfiguration();
  }
  getWalletData() {
    let id = this.route.snapshot.paramMap.get('id') || '0';
    this.rewardWalletQuery
      .selectRewardWalletItem(id)
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe((purchase: any) => {
        this.purchasedItem = purchase as MarketplaceWalletItem;
        if (this.purchasedItem.Attributes.length !== 0) {
          const myDate = this.purchasedItem.Attributes[0].DisplayValue;
          const date = DateTime.fromISO(myDate, { zone: 'utc' });

          if (DateTime.utc() > date) {
            this.showButton = false;
            return;
          }
          this.showButton = true;
          this.showCalendar = false;
          const plusHours = date.plus({ hours: 1 });
          this.calendarStartDate = date.toFormat('yyyy-MM-dd');
          this.calendarEndDate = plusHours.toFormat('yyyy-MM-dd');
          this.calendarStartTime = date.toFormat('HH:mm');
          this.calendarEndTime = plusHours.toFormat('HH:mm');
        }
      });
  }
  setConfiguration() {
    this.config = {
      name: this.purchasedItem.Name,
      description: this.purchasedItem.Description,
      startDate: this.calendarStartDate,
      endDate: this.calendarEndDate,
      startTime: this.calendarStartTime,
      endTime: this.calendarEndTime,
      timeZone: 'UTC',
      listStyle: 'overlay',
      options: ['Apple', 'Google', 'Outlook.com', 'Microsoft365'],
      inline: true,
      proOverride: true,
      hideBranding: true,
      hideBackground: true,
    };
    this.configMobile = {
      buttonStyle: 'round',
      name: this.purchasedItem.Name,
      description: this.purchasedItem.Description,
      timeZone: 'UTC',
      startDate: this.calendarStartDate,
      endDate: this.calendarEndDate,
      startTime: this.calendarStartTime,
      endTime: this.calendarEndTime,
      listStyle: 'overlay',
      options: ['Apple', 'Google', 'Outlook.com', 'Microsoft365'],
      inline: true,
      proOverride: true,
      hideBranding: true,
      hideBackground: false,
    };
  }
  toggleShowCalendarOption() {
    if (this.screenSize >= 600) {
      atcb_action(this.config, this.button);
    }
    if (this.screenSize < 600) {
      atcb_action(this.configMobile, this.button);
    }
  }
}
